import React from 'react';
import { BiLoggerContextProvider } from '../../../biLogger';
import SimpleDeviationGridBlock from '../../_partials/SimpleDeviationGridBlock';
export var Recent = function (_a) {
    var recent = _a.recent, parentDeviation = _a.parentDeviation, isLoading = _a.isLoading;
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'recent' } },
        React.createElement(SimpleDeviationGridBlock, { streamKey: "recent", parentDeviation: parentDeviation, deviations: recent, isLoading: isLoading })));
};
Recent.displayName = 'Recent';
export default Recent;
//# sourceMappingURL=Recent.js.map